import React, { useState } from 'react';

import { BlockList } from '@anwb/poncho/components/block-list';
import { ContractManagementIcon } from '@anwb/poncho/components/icon/variants/illustrative/ContractManagementIcon';
import Typography from '@anwb/poncho/components/typography';
import { trackEvent } from '@anwb/poncho/utilities/tracking';

import { ContractOverviewModal } from './ContractOverviewModal';

import StyledBlockList from './styles/overviewBlockList.styled';

export const ContractOverview = () => {
	const [open, setOpen] = useState(false);

	const handleOpen = (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.preventDefault();
		setOpen(true);
		trackEvent({
			event: 'click',
			type: 'form',
			component: 'pop-up',
			'link-text': 'lees-de-belangrijkste-voorwaarden',
		});
	};

	return (
		<>
			<StyledBlockList data-test="overview-blocklist">
				<BlockList.Item>
					<BlockList.ItemIcon>
						<ContractManagementIcon size="jumbo-xl" />
					</BlockList.ItemIcon>
					<BlockList.ItemTitle>Het Private Lease contract</BlockList.ItemTitle>
					<BlockList.ItemText>
						Bij ANWB lease je een auto voor een vast maandbedrag. Dat is inclusief onderhoud,
						verzekering, pechhulp en meer.{' '}
						<Typography
							href="#"
							variant="link-text"
							onClick={(event: React.MouseEvent<HTMLAnchorElement>) => handleOpen(event)}
						>
							Lees de belangrijkste voorwaarden
						</Typography>
					</BlockList.ItemText>
				</BlockList.Item>
			</StyledBlockList>
			<ContractOverviewModal open={open} setOpen={setOpen} />
		</>
	);
};
